import { useState } from "react"
import '../styles/pages/system.scss'

const System = () => {

  const [current, setCurrent] = useState(0)

  return (
    <div className="page-container">
      <div className="system-nav">
          <button className={`system-button basic ${current===0 && "current"}`}
            onClick={()=>{
              setCurrent(0)
            }}
          >
            <h1>Basic</h1>
          </button>
          <button className={`system-button craft ${current===1 && "current"}`}
            onClick={()=>{
              setCurrent(1)
            }}
          >
            <h1>Crafts</h1>
          </button>
          <button className={`system-button enigma ${current===2 && "current"}`}
            onClick={()=>{
              setCurrent(2)
            }}
          >
            <h1>Enigma II</h1>
          </button>
          <button className={`system-button fun ${current===3 && "current"}`}
            onClick={()=>{
              setCurrent(3)
            }}
          >
            <h1>Fun Factors</h1>
          </button>
          <button className={`system-button mini ${current===4 && "current"}`}
            onClick={()=>{
              setCurrent(4)
            }}
          >
            <h1>Minigames &amp; More</h1>
          </button>
          <button className={`system-button save ${current===5 && "current"}`}
            onClick={()=>{
              setCurrent(5)
            }}
          >
            <h1>Save Data Transfer</h1>
          </button>
      </div>
      <div className="system-wrapper">
        {
          current === 0 ? <Basic/> :
          current === 1 ? <Crafts/> :
          current === 2 ? <Enigma/> :
          current === 3 ? <FunFactors/> :
          current === 4 ? <Minigames/> :
          <SaveData/>
        }
      </div>
    </div>
  )
}

const Basic = () => {

  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <h1 className="system-title">
        Basic System
      </h1>
      <h2 className="system-caption">
        Fundamental features and mechanics carried over from The Legend of Heroes: Trails From Zero.
      </h2>  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-header">
          AT Battle
        </h1>
        <p className="system-text">
          The AT (Active Time) Battle System, a staple of the Trails series, is a deceptively simple system that centers around turn orders.
        </p>
        <p className="system-text">
          The AT bar, which indicates turn order, can impart additional AT bonuses on specified turns. These bonuses range from HP recovery to Team Rush attacks, in which you and your allies strike at the same time, inflicting massive damage.
        </p>
        <p className="system-text">
          AT bonuses are triggered by allies and enemies alike, so keep an eye on the AT bar in the upper-left corner of the screen to maximize AT bonuses to your advantage!
        </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/battle-0.png" alt="" className="system-image large" onClick={()=>{
              setCurrent(0)
              setVisible(true)
            }}/>
          </div>
        </div>
      </div>
  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-header">
            Field Attacks
          </h1>
          <p className="system-text">
            If you press the attack button while on the field map, your lead character will perform an attack. Striking an enemy with one of these field attacks will stun them, and if you engage a stunned enemy, you'll receive potent combat bonuses.
          </p>
          <p className="system-text">
            However, keep in mind that enemies can also gain these bonuses if they ambush you. The same battle can play out very differently depending on how it starts!
          </p>
          <p className="system-text">
            If your level is significantly higher than an enemy's, you can even defeat them instantly by hitting them with a field attack—no battle required!<br/>
            (Coming into contact with an enemy will lead to a normal battle)
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/battle-1.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(1)
              setVisible(true)
          }}/>
            <img src="./img/ss/battle-2.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(2)
              setVisible(true)
          }}/>
            <img src="./img/ss/battle-3.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(3)
              setVisible(true)
          }}/>
            <h1 className="image-bottom">
              Destroy enemies with a single blow!
            </h1>
          </div>
        </div>
      </div>

      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-header">
            New Mechanic: Burst
          </h1>
          <p className="system-text">
            Burst can be activated for a set number of turns when the Burst Gauge in the upper-right corner of the screen is at maximum.<br/>
            (Going too many turns without activating Burst will cause the gauge to decrease. Furthermore, all four party members must be able to act in order to activate Burst.)
          </p>
          <p className="system-text">
            Activating Burst grants a number of advantages, such as speeding up your party's turn orders, healing status ailments, and disabling cast times for arts.<br/>
            (When under the effects of Burst, the gauge is consumed with every action, allowing you to act continuously until the gauge reaches 0.)

          </p>
          <p className="system-text">
            Use this new mechanic to help Lloyd and the team overcome their foes!
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <h1 className="image-top">
              Burst Points
            </h1>
            <img src="./img/ss/battle-4.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(4)
              setVisible(true)
            }}/>
            <img src="./img/ss/battle-5.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(5)
              setVisible(true)
            }}/>
            <h1 className="image-bottom">
              Burst Activate!
            </h1>
          </div>
        </div>
      </div>

      <div className="system-center">
          <h1 className="system-header">
            New Mechanic: Back Attacks
          </h1>
          <div className="system-text">   
            In Trails to Azure, letting an enemy come into contact with you from behind will not only allow them to act first, but also wreaks havoc by disrupting your formation, forcing your support members to join the fray!
          </div>
          <div className="image-row">
            <img src="./img/ss/battle-6.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(6)
              setVisible(true)
          }}/>
            <img src="./img/ss/battle-7.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(7)
              setVisible(true)
          }}/>
          </div>
      </div>

      <div className="system-center">
          <h1 className="system-header">
            New Mechanic: Breaking Objects
          </h1>
          <system className="system-text">
            Some objects in the overworld and in dungeons, such as crates, vases, and rocks, can be broken by using Field Attacks. Destroying these objects can earn you items such as cooking ingredients, fishing bait, and sepith!
          </system>
          <div className="image-row">
            <img src="./img/ss/battle-8.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(8)
              setVisible(true)
          }}/>
            <img src="./img/ss/battle-9.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(9)
              setVisible(true)
          }}/>
            <img src="./img/ss/battle-10.png" alt="" className="system-image"  onClick={()=>{
              setCurrent(10)
              setVisible(true)
          }}/>
            <h1 className="image-bottom">
            Support Members get forced into battle!
            </h1>
          </div>
      </div>
      
      <div className={`system-modal ${visible && "visible"}`}>
        <img src={`./img/ss/battle-${current}.png`} alt="" className="system-image" />
          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==10 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>
    </>
  )
}

const Crafts = () => {

  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>    
      <div className="system-center">
        <h1 className="system-header">
          Crafts
        </h1>
        <p className="system-text">
          Crafts are special moves that are unique to each character. They can have a wide range of possible effects, from a powerful ranged attack, to healing, to enhancing your team's attributes. As your characters level up, they'll add even more powerful crafts to their arsenal.
        </p>
  
        <p className="system-text">
          Using crafts consumes CP (Craft Points). Unlike EP, which can be replenished by resting, CP can only be accumulated by dealing damage and taking attacks from enemies in battle.
        </p>
      </div>
  
      <div className="system-center">
        <h1 className="system-header">
          S-Crafts
        </h1>
        <p className="system-text">
          Extremely powerful skills unique to each character that consume all their CP to use. A character must have at least 100 CP to activate their S-Craft, but if they use it when their CP is at max, it will boost the skill's power even further!
        </p>
        <h1 className="system-sub">
          Wazy - Deadly Heaven
        </h1>
        <div className="image-row">
          <img src="./img/ss/craft-0.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(0)
                setVisible(true)
            }}/>
          <img src="./img/ss/craft-1.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(1)
                setVisible(true)
            }}/>
          <img src="./img/ss/craft-2.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(2)
                setVisible(true)
            }}/>
        </div>
      </div>
  
      <div className="system-center">
        <h1 className="system-header">
          Combo Crafts
        </h1>
        <p className="system-text">
          Combo Crafts let two party members pair up, spending 100 CP each to unleash a potent duo ability. They outperform regular crafts in both power and range and, together with S-Crafts, can be a powerful tool in battle.
        </p>
        <div className="image-row">
          <img src="./img/ss/craft-3.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(3)
                setVisible(true)
            }}/>
          <img src="./img/ss/craft-4.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(4)
                setVisible(true)
            }}/>
        </div>
      </div>
  
      <div className="system-center">
          <h1 className="system-header">
            Support Crafts
          </h1>
        <p className="system-text">
          When you have more than four members in your party, characters on standby will automatically assist your combat members during battle. Standby characters will appear in the AT bar on the left side of the screen, and when their turn is up, they'll pop in to attack foes or help the team out with a support ability.
        </p>
      </div>
  
      <div className={`system-modal ${visible && "visible"}`}>
        <img src={`./img/ss/craft-${current}.png`} alt="" className="system-image" />
          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==4 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>
    </>
  )
}

const Enigma = () => {

  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <h1 className="system-title">
        Enigma II
      </h1>
      <h1 className="system-caption">
        Introducing the latest in battle orbment technology.
      </h1>
  
      <div className="system-center">
        <h1 className="system-header">
          The Enigma II
        </h1>
        <p className="system-text">
          The latest model of battle orbment (a device can cast magic) developed by the Epstein Foundation. <br/>
          This particular version is an upgrade from a fifth-generation orbment known as an Enigma, which features communication functionality.<br/>
          A special quartz called a 'master quartz' can be placed in the center of an Enigma, allowing its user to activate more than twenty powerful new arts.
        </p>
      </div>
  
      <div className="system-center">
        <h1 className="system-header">
          New Arts
        </h1>
        <p className="system-text">
          Arts are a general term for magic performed via orbments. They are activated by consuming EP (Energy Points) during battle.<br/>
          Placing a quartz in a character's Enigma II will enhance that character's abilities.<br/>
          Additionally, certain combinations of quartz will activate a variety of different arts.<br/>
          Just like in Trails from Zero, Trails to Azure also features new arts! Utilize magic of incredible power to wipe out your enemies!
        </p>
        <h1 className="system-sub">
          Photon Shot
        </h1>
        <p className="system-text">
          Fires a heavily compressed photon bullet.
        </p>
      </div>
  
      <div className="system-center">
        <h1 className="system-sub">
          Reincarnation
        </h1>
        <p className="system-text">
          A high-level space art.
        </p>
        <p className="system-text">
          Sucks everything into a space-time rift, annihilating it.
        </p>
      </div>
  
      <h1 className="system-header">
          Master Quartz/Master Arts
      </h1>
  
      <div className="system-pair">
        <div className="system-left">
          <p className="system-text">
            Master quartz are special quartz placed in the center of the Enigma II.<br/>
            Battling with a master quartz equipped will refine and enhance it over time.
          </p>
          <p className="system-text">
            Strengthening a master quartz enough will eventually give you access to a special art known as a master art.<br/>
            (Unlike normal arts, these can be used continuously during battle and affect the entire party.)
          </p>
          <p className="system-text">
            Unlike ordinary quartz, master quartz cannot be synthesized or mass-produced in a standard orbment factory.
          </p>
        </div>
        <div className="system-right">
          <img src="./img/ss/arts-0.png" alt="" className="system-image large"  onClick={()=>{
                setCurrent(0)
                setVisible(true)
            }}/>
        </div>
        <div className="image-row">
          <img src="./img/ss/arts-1.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(1)
                setVisible(true)
            }}/>
          <img src="./img/ss/arts-2.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(2)
                setVisible(true)
            }}/>
          <div className="image-bottom">
            Develop master quartz for more power!
          </div>
        </div>
      </div>

      <div className={`system-modal ${visible && "visible"}`}>
        <img src={`./img/ss/arts-${current}.png`} alt="" className="system-image" />
          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==2 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>
    </>
  )
}

const FunFactors = () => {
  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <h1 className="system-title">
        Fun Factors
      </h1>
      <h2 className="system-caption">
        Introducing the thrilling attractions at Crossbell's very own theme park.
      </h2>
      <div className="system-pair">
        <div className="system-left">
        <h1 className="system-header">
          Mishelam Wonderland
        </h1>
        <p className="system-text">
          At Mishelam Wonderland, you can enjoy numerous attractions by expending tickets given to you during the story. As each activity costs one ticket, who you choose to accompany you to which attractions will be the key the maximizing your theme park fun.
        </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/fun-0.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(0)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
      <div className="system-pair">
        <div className="system-left">
        <h1 className="system-sub">
          Sunshine Mall - Ferris Wheel
        </h1>
        <p className="system-text">
          Located on the left side of the theme park is a giant ferris wheel that offers the best views of Mishelam from its gondolas. Whoever you choose to join the ride will get to spend a bit of alone time with Lloyd. An opportunity like this  just may bring out a private conversation or two...
        </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/fun-1.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(1)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
      
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-sub">
            Fortune-Teller
          </h1>
          <p className="system-text">
            Here, you can have your fortune read by a highly-skilled soothsayer.<br/>
            You can ask for a compatibility reading between Lloyd and a partner of your choice, but it might be interesting to see what your partner chooses as well...
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/fun-2.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(2)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>

      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-sub">
            Horror Coaster
          </h1>
          <p className="system-text">
            A hair-raising attraction where Lloyd and a partner must go on a coaster ride through a haunted mansion armed with an orbal gun. Netting a high score may earn you a nice surprise.
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/fun-3.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(3)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
      
      <div className="system-center">
        <h1 className="system-header">
          Lakeside Beach
        </h1>
        <p className="system-text">
          A stunning beach by Lake Elm, newly created as part of Mishelam's redevelopment.<br/>
          Not only can you see the ladies in their swimsuits, there are also a number of fun hidden events exclusive to the beach!
        </p>
        <div className="image-row">
          <img src="./img/ss/fun-4.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(4)
                setVisible(true)
            }}/>
          <img src="./img/ss/fun-5.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(5)
                setVisible(true)
            }}/>
          <img src="./img/ss/fun-6.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(6)
                setVisible(true)
            }}/>
        </div>
      </div>

      <div className={`system-modal ${visible && "visible"}`}>
        <img src={`./img/ss/fun-${current}.png`} alt="" className="system-image" />
          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==6 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>

    </>
  )
}



const Minigames = () => {

  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <h1 className="system-title">
        Minigames and More
      </h1>
      <h1 className="system-caption"></h1>
      <div className="system-pair">
        <div className="system-left">
          <p className="system-text">
            Pom! Pom! Party!: The Competitive Puzzle Game
          </p>
          <p className="system-text">
            Now you can play Pom! Pom! Party! too, just as Tio and Jona were in Trails from Zero!
          </p>
          <p className="system-text">
            Complete requests and events to collect account IDs from a multitude of characters, then triumph against them in battle to become Crossbell's top Pom Master!
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/mini-0.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(0)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
  
      <div className="system-pair">
        <div className="system-left">
          <div className="system-sub">
            How to Play Pom! Pom! Party!
          </div>
          <ul className="system-list">
            <li>
              Control the poms (pom pom-like monsters from the Trails series) falling from the top of the screen to match three of the same color and clear them from the screen.
            </li>
            <li>
              Each pom cleared earns you 1 CP. Once you have accumulated over 100 CP, press △ + L or △ + R to unleash a powerful S-Craft.<br/>
              (L for defensive, R for offensive)
            </li>
          </ul>
          <p className="system-text">
            Complete requests and events to collect account IDs from a multitude of characters, then triumph against them in battle to become Crossbell's top Pom Master!
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <img src="./img/ss/mini-1.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(1)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
  
      <div className="system-header">
        Orbal Car Customization
      </div>
      <div className="system-pair">
        <div className="system-left">
          <p className="system-text">
            The Special Support Section hits the road with a brand new orbal car!
          </p>
          <p className="system-text">
            With it, you can now travel to your destination in an instant without having to take the bus, making side trips and support requests easier than ever!<br/>
            (Simply select a destination on the map to drive there.)
          </p>
        </div>
        <div className="system-right">
          <div className="img-list">
            <img src="./img/ss/mini-2.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(2)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
  
      <div className="system-center">
        <p className="system-text">
          By purchasing parts at the store or reading car magazines, you can change color palettes, replace parts, and customize the car in a variety of ways!<br/>        
          (You can even equip the orbal car with special functions, such as HP recovery.)
        </p>
        <div className="image-row">
          <img src="./img/ss/mini-3.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(3)
                setVisible(true)
            }}/>
          <img src="./img/ss/mini-4.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(4)
                setVisible(true)
            }}/>
          <img src="./img/ss/mini-5.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(5)
                setVisible(true)
            }}/>
        </div>
      </div>
  
      <h1 className="system-header">
        Decorations
      </h1>
  
      <div className="system-center">
        <p className="system-text">
          Back by popular demand from Trails from Zero, room decorations return in Trails to Azure! Furnish each SSS member's room by collecting decorations specifically geared toward them!
        </p>
        <p className="system-text">
          Special events occur for each character when you collect all of their decorations!
          You may be able to learn information about the SSS members' hobbies and hidden depths that can't be found anywhere else...
        </p>
        <p className="system-text">
          Furthermore, it's now possible to furnish KeA's room!
          Collect all of KeA's decorations to unlock an event that involves every member of the SSS!
        </p>
      </div>
  
      <h1 className="system-header">
        Fishing Event
      </h1>
      
      <div className="system-center">
          <p className="system-text">
            The Crossbell branch of the Fisherman's Guild finds itself in trouble when the Imperial Fishing Club, led by Lakelord III, comes out of nowhere one day and takes over their building!
          </p>
          <p className="system-text">
            In order to reclaim their branch, the members of the Fisherman's Guild challenge the Imperial Fishing Club to a series of anglers' duels.<br/>
            As a fellow fishing aficionado, Lloyd must take on these anglers' duels to liberate the fishing holes that Lakelord and his comrades are holding hostage!
          </p>
          <h1 className="system-sub">
          About Anglers' Duels
        </h1>
        <ul className="system-list">
          <li>
            In Trails to Azure, certain fishing holes have been taken over by the Imperial Fishing Club.
          </li>
          <li>
            By defeating the members of their Elite Four, you can reclaim the fishing holes they are occupying.<br/>
            (Each Elite Four member has certain conditions that must be met before you may challenge them.)
          </li>
        </ul>
      </div>

      <div className={`system-modal ${visible && "visible"}`}>
          <img src={`./img/ss/mini-${current}.png`} alt="" className="system-image" />
          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==5 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>
    </>
  )
}


const SaveData = () => {

  const [current, setCurrent] = useState(0)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <h1 className="system-title">
        Save Data Transfer
      </h1>
      <h2 className="system-caption">
        Cleared save data from Trails from Zero can be transferred to Trails to Azure!
      </h2>
  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-header">
            Transferring clear data from Zero to Azure
          </h1>
          <ul className="system-list">
            <li>
              Using cleared save data from Trails from Zero will provide you with bonuses to help enjoy Trails to Azure even more.
            </li>
            <li>
              Additionally, some dialogue in Trails to Azure will change depending on what support requests you have completed and which NPCs you have met in Trails from Zero.
            </li>
          </ul>
        </div>
        <div className="system-right">
          <div className="special-wrapper">
            <div className="black-silver">
              <h1>
                [Major Transfer Bonuses]
              </h1>
              <ul>
                <li>Clear data character levels</li>
                <li>Events experienced</li>
                <li>Bond levels with Elie/Tio/Randy</li>
                <li>Fishing Rank</li>
                <li>Detective Rank</li>
                <li>Combo Crafts</li>
                <li>...and more!</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  
      <div className="system-center">
        <h1 className="system-sub">
          [About Bond Levels]
        </h1>
        <p className="system-text">
          Bond levels will be transferred all at once. This applies to any save data.<br/>
          For example, if you have cleared Trails from Zero three times, transferring data at the beginning of Azure will transfer the bond levels from all three playthroughs combined.<br/>
          As such, even if you choose a different clear data from Zero on a second playthrough of Azure, the bonding events in Azure will not change from the first playthrough.
        </p>
      </div>
  
      <div className="system-center">
        <h1 className="system-sub">
          [Levels and Ranks (Aside from Bonding)]
        </h1>
        <p className="system-text">
          All achievements from cleared save data will be transferred. If you have played through Trails from Zero multiple times, it is recommended that you transfer the save data with the most achievements.
        </p>
      </div>
      
      <h1 className="system-header">
        Story Variation Examples
      </h1>
  
      <div className="system-center">
        <p className="system-sub">
          Transfer Example 1:
        </p>
        <p className="system-text">
          Lloyd fighting an archaism.<br/>
          Completing a special event that only occurs in a subsequent playthrough of Trails from Zero will alter the dialogue in Trails to Azure.
        </p>
        <div className="system-subpair">
        <div className="system-left">
          <h1 className="save-caption">
            If you have cleared support requests in Zero.
          </h1>
          <img src="./img/ss/save-0.png" alt="" className="system-image large"  onClick={()=>{
                setCurrent(0)
                setVisible(true)
            }}/>
        </div>
        <div className="system-right">
          <h1 className="save-caption">
            If you have not cleared support requests in Zero.
          </h1>
          <img src="./img/ss/save-1.png" alt="" className="system-image large"  onClick={()=>{
                setCurrent(1)
                setVisible(true)
            }}/>
        </div>
      </div>
      </div>
  
      
  
      <div className="system-center">
        <p className="system-sub">
          Transfer Example 2:
        </p>
        <p className="system-text">
          By taking on a certain support request in Trails from Zero, Lloyd and the team will become acquainted with Sully, the newest member of Arc en Ciel.<br/>
          Depending on whether or not you have completed the request, the dialogue between Lloyd and Sully will differ.
        </p>
      </div>
  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="save-caption">
            If you have cleared support requests in Zero.
          </h1>
          <img src="./img/ss/save-2.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(2)
                setVisible(true)
            }}/>
        </div>
        <div className="system-right">
          <h1 className="save-caption">
            If you have not cleared support requests in Zero.
          </h1>
          <img src="./img/ss/save-3.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(3)
                setVisible(true)
            }}/>
        </div>
      </div>
  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-sub">
            Transfer Example 3:
          </h1>
          <p className="system-text">
            Noel meets Shizuku at the Bracer's Guild for the first time.<br/>
            Apparently, she has already heard about Shizuku from her sister, Fran.
          </p>
          <p className="system-text">
            *If Noel has already met Shizuku in Zero, the dialogue between them will differ in Azure, as they are already acquainted.
          </p>
        </div>
        <div className="system-right">
          <div className="img-list">
            <img src="./img/ss/save-4.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(4)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>
  
      <h1 className="system-header">
        Bonding Event Transfer Example
      </h1>
  
      <div className="system-center">
        <p className="system-text">
          Bonds can be deepened by selecting specific characters and completing requests and minigames together during the game. Doing this can cause special "Bonding Events" to occur.
        </p>
        <p className="system-text">
          Deepening bonds between characters in Trails from Zero will lead to changes in Trails to Azure!
        </p>
        <h1 className="system-sub">
          If you have seen Elie's Bonding Event in Zero
        </h1>
        <p className="system-text">
          Lloyd and Elie deepen their relationship in an event at the IBC in Trails from Zero. If you have seen this event, you will be able to notice a subtle shift in Lloyd and Elie's interactions as they maneuver around their shared feelings for one another.
        </p>
        <h1 className="system-sub">
          If you have seen Tio's Bonding Event in Trails from Zero
        </h1>
        <p className="system-text">
          Lloyd recalls a promise he made with Tio at the IBC.<br/>
          In another scene, Tio will react to that event in Trails to Azure.
        </p>
        <div className="image-row">
          <img src="./img/ss/save-5.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(5)
                setVisible(true)
            }}/>
          <img src="./img/ss/save-6.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(6)
                setVisible(true)
            }}/>
        </div>
        <h1 className="system-sub">
          If you have deepened your bond with multiple characters in Zero
        </h1>
        <p className="system-text">
          ⇒ If you have strengthened the Combo Crafts between Lloyd, Elie, Tio, and Randy by seeing their respective events, their Combo Crafts will already be strengthened when they rejoin in Trails to Azure.
        </p>
        <p className="system-text indent">
          Example:<br/>
          If you have strengthened Lloyd and Elie's Combo Craft by watching the corresponding event in your first playthrough of Zero, and done the same for Tio in a second playthrough, Lloyd's Combo Crafts with both girls will already be strengthened when you meet them in Azure.
        </p>
        <p className="system-text">
          ⇒ At certain points, you will have to choose who you have bonded with in the past. Bonding events will diverge according to your decisions.
        </p>
      </div>
  
      <div className="system-pair">
        <div className="system-left">
          <h1 className="system-sub">
            There are even hidden bonding events with some people outside of the SSS!
          </h1>
          <p className="system-text">
            As an extra element, Trails to Azure features quests and conversations that let you deepen Lloyd's relationship with side characters.
          </p>
          <p className="system-text">
            Play your cards right, and you may be able to see bonding events with Rixia, Dudley, KeA, and more!
          </p>
        </div>
        <div className="system-right">
          <div className="image-list">
            <h1 className="image-top">
              You can even bond with side characters!
            </h1>
            <img src="./img/ss/save-7.png" alt="" className="system-image"  onClick={()=>{
                setCurrent(7)
                setVisible(true)
            }}/>
          </div>
        </div>
      </div>

      <div className={`system-modal ${visible && "visible"}`}>

          <img src={`./img/ss/save-${current}.png`} alt="" className="system-image" />

          <div className="button-wrapper">
          {
            current!==0 && <button className="previous"
              onClick={()=>{
                setCurrent(current-1)
              }}
            >
              Previous
            </button>
          }
          {
            current!==7 && <button className="previous"
              onClick={()=>{
                setCurrent(current+1)
              }}
            >
              Next
            </button>
          }
          </div>
          <button className="close"
            onClick={()=>{
              setVisible(false)
            }}
          >
            Close
          </button>
      </div>
    </>
  )
}

export default System;